import { useContext } from 'react'
import styles from './RestorePassword.module.scss'
import { GlobalNotificationContext } from '../../../Context/GlobalNotification/GlobalNotificationProvider'
import { GlobalLoaderContext } from '../../../Context/GlobalLoader/GlobalLoader'
import { NotificationType } from '../../../Context/GlobalNotification/Types'
import { restorePassword } from '../../../service/User/api'
import { LoginPageType, LoginPageTypes } from '../LoginPageTypes'
import { RestorePasswordProps } from '../../../service/FormGenerator/FormDefinitions/zodSchema/restorePasswordSchema'
import { RHFSimpleFormBuilder } from '../../../service/FormGenerator/RHFSimpleFormBuilder'
import { formsDefinitions } from '../../../service/FormGenerator/FormDefinitions'
import sharedStyles from '../../../sharedStyles.module.scss'

interface Props {
  changeFormHandler: (formType: LoginPageTypes) => void
}

export const RestorePassword = ({ changeFormHandler }: Props): JSX.Element => {
  const showLoader = useContext(GlobalLoaderContext)
  const showNotification = useContext(GlobalNotificationContext)

  const onSubmit = async (credentials: RestorePasswordProps) => {
    showLoader(true)
    try {
      await restorePassword(credentials.email)
      showNotification(
        NotificationType.INFO,
        'Mail został poprawnie wysłany. Sprawdź zakładkę SPAM'
      )
    } catch (err) {
      showNotification(NotificationType.ERROR, 'Coś poszło nie tak')
    }
    showLoader(false)
  }

  return (
    <section>
      <RHFSimpleFormBuilder
        formDefinition={formsDefinitions.restorepassword}
        onSubmit={onSubmit}
      />

      <div className={styles.AdditionalInfoContainer}>
        <p>
          <button
            type='button'
            onClick={(): void => changeFormHandler(LoginPageType.LOGIN)}
            className={sharedStyles.ButtonToInternalLink}
          >
            Kliknij
          </button>
          <span>, żeby wrócić</span>
        </p>
      </div>
    </section>
  )
}
